import { useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import { StatefulControlledTextField } from "components/Core/StatefulControlledTextField";

export function PromptDialog({
  title,
  prompt,
  promptDetail,
  open,

  onClickConfirm,
  onClickCancel,
}) {
  const [inputValue, setInputValue] = useState(null);

  const handleTextFieldOnChange = (e) => {
    setInputValue(e?.target?.value);
  };

  return (
    <Dialog open={open}>
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>

      <DialogContent>
        <Typography variant="body1">{prompt}</Typography>

        <StatefulControlledTextField fullWidth onChange={handleTextFieldOnChange} defaultValue={""} />
      </DialogContent>

      {promptDetail && (
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{promptDetail}</DialogContentText>
        </DialogContent>
      )}

      <DialogActions>
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" justifyContent="flex-end">
          <Button
            variant="contained"
            onClick={() => {
              onClickConfirm(inputValue);
              setInputValue(null);
            }}
          >
            OK
          </Button>
          <Button variant="contained" color="secondary" autoFocus onClick={onClickCancel}>
            Cancel
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
